/* vl-set — medical pillow sets (Faz 2 PDF 3.1–3.3).
   1. Set strips on single pillow pages ([data-vl-set-add], rendered by
      snippets/vl-set-strip.liquid): add the set to the cart, then open the set
      page with ?vl_set_added=1.
   2. <vl-set> set page (sections/vl-set.liquid): gallery, quantity, add to
      cart (the set's cart items × quantity), buy now and havale checkout links,
      the fixed-end countdown, and the "added" toast when a strip sent the
      shopper.
   The cart items come from data-items (JSON): either the set product or the
   parts, each labelled with the set name. */
(function () {
  'use strict';
  if (window.vlSetInit) return;
  window.vlSetInit = true;

  function parseItems(el) {
    try { return JSON.parse(el.getAttribute('data-items') || '[]'); } catch (e) { return []; }
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      /* a refused add (sold out…) throws Shopify's JSON so the pop-up can show its reason (2026-10-16) */
      return r.json().then(function (j) { if (!r.ok) throw j; return j; }, function () { if (!r.ok) throw new Error('cart add ' + r.status); return {}; });
    });
  }
  function times(items, q) {
    return items.map(function (it) {
      var o = { id: it.id, quantity: (it.quantity || 1) * q };
      if (it.properties) o.properties = it.properties;
      return o;
    });
  }
  /* cart permalink: straight to checkout; it cannot carry line properties */
  function permalink(items, q) {
    return '/cart/' + items.map(function (it) { return it.id + ':' + (it.quantity || 1) * q; }).join(',');
  }
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('hdt-cart-count, .cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:count:update', { detail: { item_count: c.item_count } }));
    }).catch(function () {});
    document.dispatchEvent(new CustomEvent('cart:reload'));
  }

  /* 1. strips */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vl-set-add]');
    if (!btn || btn.dataset.busy) return;
    e.preventDefault();
    var items = parseItems(btn);
    var url = btn.getAttribute('data-url') || '/';
    if (!items.length) { window.location.href = url; return; }
    btn.dataset.busy = '1';
    btn.classList.add('is-busy');
    addItems(items)
      .then(function () {
        window.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'vl_set_added=1';
      })
      .catch(function () {
        delete btn.dataset.busy;
        btn.classList.remove('is-busy');
        window.location.href = url;
      });
  });

  /* 2. set page */
  class VlSet extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.items = parseItems(this);

      /* gallery — thumbnails and side arrows, as on the product page */
      var mainImg = this.querySelector('.vl-mp__main img');
      var thumbs = Array.prototype.slice.call(this.querySelectorAll('.vl-mp__thumb'));
      var show = function (t) {
        if (!t || !mainImg || !t.dataset.src) return;
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (t.dataset.srcset) mainImg.setAttribute('srcset', t.dataset.srcset);
        else mainImg.removeAttribute('srcset');
        mainImg.src = t.dataset.src;
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });
      this.querySelectorAll('[data-vl-gal]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!thumbs.length) return;
          var cur = thumbs.findIndex(function (x) { return x.classList.contains('active'); });
          if (cur < 0) cur = 0;
          var step = parseInt(btn.dataset.vlGal, 10) || 1;
          show(thumbs[(cur + step + thumbs.length) % thumbs.length]);
        });
      });

      var qtyInput = this.querySelector('.vl-mp__qty input');
      var qty = function () { return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1; };
      this.querySelectorAll('.vl-mp__qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          qtyInput.value = Math.max(1, qty() + (parseInt(b.dataset.step, 10) || 0));
        });
      });

      var toast = function (text) {
        var t = document.querySelector('.vl-set-toast');
        if (!t) return;
        var span = t.querySelector('[data-toast-text]');
        if (text && span) span.textContent = text;
        t.classList.add('show');
        setTimeout(function () { t.classList.remove('show'); }, 2600);
      };

      var atc = this.querySelector('.vl-mp__atc');
      if (atc) {
        atc.addEventListener('click', function () {
          if (atc.dataset.busy || !self.items.length) return;
          atc.dataset.busy = '1';
          var labelEl = atc.querySelector('.vl-mp__atc-txt') || atc;
          var label = labelEl.innerHTML;
          labelEl.textContent = 'Ekleniyor...';
          /* 2026-10-16: the "Ürün başarıyla sepetinize eklendi" pop-up (assets/vl-added.js) instead of the toast */
          var va = window.vlAdded || null;
          var meta = { opener: atc, image: mainImg ? (mainImg.currentSrc || mainImg.src) : '' };
          if (va) va.begin(meta);
          addItems(times(self.items, qty()))
            .then(function (resp) { if (va) va.done(resp, meta); else toast(); refreshCart(); })
            .catch(function (err) { if (va) { va.fail(err && (err.description || err.message) ? err : ''); return; } window.location.href = '/cart'; })
            .finally(function () { delete atc.dataset.busy; labelEl.innerHTML = label; });
        });
      }

      var buynow = this.querySelector('[data-vl-buynow]');
      if (buynow) {
        buynow.addEventListener('click', function () {
          if (!self.items.length) return;
          window.location.href = permalink(self.items, qty());
        });
      }

      /* havale — same checkout link, plus the cart attribute (and code, if any)
         the bank-transfer discount keys on; see snippets/vl-havale-cta.liquid */
      var havale = this.querySelector('[data-vl-havale][data-vl-havale-context="product"]');
      if (havale) {
        havale.addEventListener('click', function () {
          if (!self.items.length) return;
          var attr = havale.getAttribute('data-vl-havale-attr') || 'havale';
          var code = havale.getAttribute('data-vl-havale-code') || '';
          var url = permalink(self.items, qty()) + '?attributes[odeme_yontemi]=' + encodeURIComponent(attr);
          if (code) url += '&discount=' + encodeURIComponent(code);
          window.location.href = url;
        });
      }

      /* countdown to one fixed moment, Türkiye time (UTC+3 all year) */
      this.querySelectorAll('[data-vl-countdown-end]').forEach(function (box) {
        var m = (box.getAttribute('data-vl-countdown-end') || '').match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
        if (!m) return;
        var end = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] - 3, +m[5]);
        var seg = function (name) { return box.querySelector('.vl-mp__seg[data-seg="' + name + '"]'); };
        var d = seg('d'), h = seg('h'), mi = seg('m'), s = seg('s');
        var pad = function (n) { return ('0' + n).slice(-2); };
        var timer = null;
        var tick = function () {
          var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
          if (d) d.textContent = String(Math.floor(left / 86400));
          left = left % 86400;
          if (h) h.textContent = pad(Math.floor(left / 3600));
          if (mi) mi.textContent = pad(Math.floor((left % 3600) / 60));
          if (s) s.textContent = pad(left % 60);
          if (end <= Date.now() && timer) clearInterval(timer);
        };
        tick();
        timer = setInterval(tick, 1000);
      });

      /* arrived from a strip that already put the set in the cart */
      if (/[?&]vl_set_added=1(&|$)/.test(window.location.search)) {
        toast(this.getAttribute('data-added-text'));
        refreshCart();
        try {
          var u = new URL(window.location.href);
          u.searchParams.delete('vl_set_added');
          window.history.replaceState(null, '', u.toString());
        } catch (e) {}
      }
    }
  }
  if (!customElements.get('vl-set')) customElements.define('vl-set', VlSet);
})();
